import React, { PropTypes } from "react";
import BillingPeriodField from "../BillingPeriodField";

const coverageStatusesForm = ({ billingPeriods }) => (
  <BillingPeriodField
    id="billingPeriodId"
    name="billingPeriodId"
    billingPeriods={billingPeriods}
  />
);
coverageStatusesForm.propTypes = { billingPeriods: PropTypes.array.isRequired };
export default coverageStatusesForm;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/coverageStatuses/coverageStatusesForm.js